import {
    UPDATE_TEMPLATE_DETAILS,
    UPDATE_TEMPLATE_DETAILS_SUCCESS,
    UPDATE_TEMPLATE_DETAILS_FAILURE,
    RESET_UPDATE_TEMPLATE_DETAILS
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    updateTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
        uid:'',
    },
};

const UpdateTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_TEMPLATE_DETAILS:
            return {
                ...state,
                updateTemplate: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case UPDATE_TEMPLATE_DETAILS_SUCCESS:
            return {
                ...state,
                updateTemplate: {
                    loading: false,
                    statusCode: action.payload?.statusCode,
                    statusMessage: action.payload?.statusMessage,
                    uid:action.payload?.templateUid,
                },
            };
        case UPDATE_TEMPLATE_DETAILS_FAILURE:
            return {
                ...state,
                updateTemplate: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case RESET_UPDATE_TEMPLATE_DETAILS:
            return {
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }

};

export default UpdateTemplateReducer;
